export const ROLES = {
  SUPERADMIN: "SUPERADMIN",
  DOCTOR: "DOCTOR",
  PUBLIC: "PUBLIC",
} as const;

export type RoleType = typeof ROLES[keyof typeof ROLES];
